import { parseEnumFilter, parseNumberFilter, toFilterText } from '@/utils/filters';
import { SUBMISSION_STATUS, SUBMISSION_TYPE } from '../constants/instituteSubmission.constants';
import type { InstituteSubmissionFilters } from '../types/filters.types';
import type {
  InstituteSubmissionCountsBySubmitterParams,
  InstituteSubmissionSearch,
  InstituteSubmissionSummaryParams,
} from '../types/instituteSubmission.types';

type InstituteSubmissionFilterSearch = Pick<
  InstituteSubmissionSearch,
  | 'reviewStatus'
  | 'submissionType'
  | 'instituteTypeId'
  | 'districtId'
  | 'thanaId'
  | 'amUserId'
  | 'zmUserId'
  | 'dateFrom'
  | 'dateTo'
>;

export function toFilterValues(search: InstituteSubmissionSearch): InstituteSubmissionFilters {
  return {
    status: toFilterText(search.reviewStatus),
    submissionType: toFilterText(search.submissionType),
    instituteTypeId: toFilterText(search.instituteTypeId),
    districtId: toFilterText(search.districtId),
    thanaId: toFilterText(search.thanaId),
    amUserId: toFilterText(search.amUserId),
    zmUserId: toFilterText(search.zmUserId),
    dateFrom: toFilterText(search.dateFrom),
    dateTo: toFilterText(search.dateTo),
  };
}

export function toSearchFilters(
  filters: InstituteSubmissionFilters,
): InstituteSubmissionFilterSearch {
  return {
    reviewStatus: parseEnumFilter(filters.status, SUBMISSION_STATUS),
    submissionType: parseEnumFilter(filters.submissionType, SUBMISSION_TYPE),
    instituteTypeId: parseNumberFilter(filters.instituteTypeId),
    districtId: parseNumberFilter(filters.districtId),
    thanaId: parseNumberFilter(filters.thanaId),
    amUserId: parseNumberFilter(filters.amUserId),
    zmUserId: parseNumberFilter(filters.zmUserId),
    dateFrom: filters.dateFrom || undefined,
    dateTo: filters.dateTo || undefined,
  };
}

export function clearDependentFilters(
  previous: InstituteSubmissionFilters,
  next: InstituteSubmissionFilters,
): InstituteSubmissionFilters {
  const amChanged = next.amUserId !== previous.amUserId;
  const districtChanged = next.districtId !== previous.districtId;

  return {
    ...next,
    ...(amChanged ? { zmUserId: '' } : {}),
    ...(districtChanged ? { thanaId: '' } : {}),
  };
}

export function toSummaryParams(
  search: InstituteSubmissionSearch,
): InstituteSubmissionSummaryParams {
  return {
    submissionType: search.submissionType,
    instituteTypeId: search.instituteTypeId,
    districtId: search.districtId,
    thanaId: search.thanaId,
    amUserId: search.amUserId,
    zmUserId: search.zmUserId,
    dateFrom: search.dateFrom,
    dateTo: search.dateTo,
    search: search.search,
  };
}

export function toCountsBySubmitterParams(
  search: InstituteSubmissionSearch,
): InstituteSubmissionCountsBySubmitterParams {
  return {
    status: search.reviewStatus,
    submissionType: search.submissionType,
    instituteTypeId: search.instituteTypeId,
    districtId: search.districtId,
    thanaId: search.thanaId,
    dateFrom: search.dateFrom,
    dateTo: search.dateTo,
    search: search.search,
  };
}
